import { render, staticRenderFns } from "./VerifyEmail.vue?vue&type=template&id=af0bc710&scoped=true&"
import script from "./VerifyEmail.vue?vue&type=script&lang=js&"
export * from "./VerifyEmail.vue?vue&type=script&lang=js&"
import style0 from "./VerifyEmail.vue?vue&type=style&index=0&id=af0bc710&scoped=true&lang=css&"
import style1 from "./VerifyEmail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0bc710",
  null
  
)

export default component.exports